/* global PIXI */
import merge from 'lodash/merge';

module.exports = (obj, opts) => {
    const object = merge({
        texture: null,
        type: 'sprite',
        anchor: {
            x: 0,
            y: 0,
        },
        pivot: {
            x: 0,
            y: 0,
        },
        scale: {
            x: 1,
            y: 1,
        },
        tileScale: {
            x: 1,
            y: 1,
        },
    }, obj, opts);

    let sprite;

    if (object.type === 'movieclip') {
        sprite = new PIXI.extras.AnimatedSprite(object.texture);
    } else if (object.type === 'tilingSprite') {
        sprite = new PIXI.extras.TilingSprite(
            object.texture, object.texture.frame.width, object.texture.frame.height);
        sprite.tileScale = new PIXI.Point(object.tileScale.x, object.tileScale.y);
    } else {
        sprite = new PIXI.Sprite(object.texture);
    }

    sprite.interactive = false;

    sprite.anchor.x = object.anchor.x;
    sprite.anchor.y = object.anchor.y;
    sprite.pivot.x = object.pivot.x;
    sprite.pivot.y = object.pivot.y;

    return sprite;
};



// WEBPACK FOOTER //
// ./js/lib/createSprite.js